import { render, staticRenderFns } from "./MonthlyAmountTable.vue?vue&type=template&id=49792592&scoped=true&"
import script from "./MonthlyAmountTable.vue?vue&type=script&lang=ts&"
export * from "./MonthlyAmountTable.vue?vue&type=script&lang=ts&"
import style0 from "./MonthlyAmountTable.vue?vue&type=style&index=0&id=49792592&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49792592",
  null
  
)

export default component.exports